var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('institution-picker-dialog',{attrs:{"preselect":_vm.preselect,"preselect-name":_vm.preselectName,"employee":_vm.employee,"value":_vm.value,"mode":"plan"},on:{"input":function($event){return _vm.$emit('input', $event)},"update:employee":function($event){return _vm.$emit('update:employee')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }